export function createTenantEntitlementClient(transport) {
    return {
        /**
         * List every entitlement this tenant holds
         *
         * Requires scope: tenant:entitlement:read
         */
        listTenantEntitlements(tenantId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/entitlements`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Read the currently effective entitlement
         *
         * Requires scope: tenant:entitlement:read
         */
        getTenantsEntitlements(tenantId, capability, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/entitlements/${encodeURIComponent(capability)}`,
                options,
            });
        },
        /**
         * Create or revise an entitlement
         *
         * Requires scope: tenant:entitlement:write
         */
        putTenantsEntitlements(tenantId, capability, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/entitlements/${encodeURIComponent(capability)}`,
                body,
                options,
            });
        },
        /**
         * List the plans tenants can buy
         *
         * Requires scope: plan:platform:read
         */
        listSubscriptionPlans(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/plans",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Define a plan tenants can buy
         *
         * Requires scope: plan:platform:write
         */
        createSubscriptionPlan(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/platform/plans",
                body,
                options,
            });
        },
        /**
         * Rename, reprice or retire a plan
         *
         * Requires scope: plan:platform:write
         */
        reviseSubscriptionPlan(planId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/platform/plans/${encodeURIComponent(planId)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=tenant-entitlement.js.map